import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { Buffer } from 'buffer'

const Content = ({ content }) => {
    const maxContentLength = 9;
    const contentLength = content.split('\n').length;
    const contentLengthCondition = maxContentLength > contentLength;
    const shortenedContent = `${String(content).substring(0, maxContentLength)}...`;

    const [expandContent, setExpandContent] = useState(contentLengthCondition);

    function expand() {
        setExpandContent(!expandContent);
    }

    return (
        <Typography variant="body2" color="common.white" sx={{ justifyContent: 'left', textAlign: 'left', alignItems: 'left', padding: '10px 10px' }} >
            {expandContent
                ? content.split('\n').map((line, index) => (<React.Fragment key={index}>{line}<br /></React.Fragment>))
                : shortenedContent.split('\n').map((line, index) => (<React.Fragment key={index}>{line}<br /></React.Fragment>))
            }
            {!contentLengthCondition && <button className="derupt-button" onClick={expand}>{expandContent ? "view less" : "view more"}</button>}
        </Typography>
    );
};

export default Content;